import type { SelectProps } from "antd";

/** Match option label, children text, or value (covers `options` and `<Option>` usage). */
export const defaultSelectFilterOption: NonNullable<SelectProps["filterOption"]> = (
  input,
  option
) => {
  const search = input.trim().toLowerCase();
  if (!search) return true;

  const candidate = option?.label ?? option?.children ?? option?.value ?? "";
  return String(candidate).toLowerCase().includes(search);
};

/** Applied app-wide via ConfigProvider — all Ant Design Selects become searchable by default. */
export const antdSelectDefaults: SelectProps = {
  showSearch: true,
  optionFilterProp: "label",
  filterOption: defaultSelectFilterOption,
};
